const ssrData = {
  synonyms: [
    {
      name: 'ALGO_ONE',
      value: ['SSI5', 'SPAK', 'SMD7', 'SKLB', 'SXAI'],
    },
    {
      name: 'ALGO_TWO',
      value: ['SRX5', 'SRDJ', 'SLAK', 'SKD7', 'SBZ2'],
    },
    {
      name: 'ALGO_THREE',
      value: ['SPGR', 'SMDJ', 'SMXT', 'SZQZ', 'SLXT'],
    },
    {
      name: 'ALGO_FOUR',
      value: ['SSXT', 'SLZ2', 'SRXT', 'SAI5', 'SBI5'],
    },
    {
      name: 'ALGO_FIVE',
      value: ['SLD7', 'SQXJ', 'SOXT', 'SBFD', 'SYXT'],
    },
    {
      name: 'ALGO_SIX',
      value: ['SLUM', 'SQAI', 'SORM', 'SBOH', 'SYAM'],
    },
  ],
  api_data: [
    {
      source: 'booking',
      id: 'sdlkd2l3',
    },
    {
      source: 'details',
      id: 'eue3kds',
    },
    {
      source: 'checkout',
      id: 'wxesdumi',
    },
    {
      source: 'search',
      id: 'xmncx278',
    },
    {
      source: 'smartfill',
      id: 'wiuwejk2',
    },
    {
      source: 'review',
      id: 'eue3kds',
    },
  ],
};

export default ssrData;
